import Point from "slotworks/utils/geom/point";
import * as PIXI from 'pixi.js';
export type PIXIElement = PIXI.Sprite | PIXI.Container | PIXI.Text;

export function Group(targets: PIXIElement | PIXIElement[], containerName: string = "tempContainer"): PIXIElement {
    if (targets === null) {
        throw new Error("Trying to group a null object");
    }

    if ((targets as any).length) {
        targets = [...(targets as PIXIElement[])];
        const parent = targets[0].parent;
        const origDepth = parent.getChildIndex(targets[0]);
        const container = new PIXIGroup();
        container.originalHierarchy = [...parent.children];

        let groupDepth = origDepth;
        for (const target of targets) {
            if (parent.getChildIndex(target) < origDepth) {
                groupDepth--;
            }
        }

        for (const target of targets) {
            container.addChild(target);
        }

        const bounds = container.getBounds();

        container.x = bounds.x;
        container.y = bounds.y;

        for (const target of targets) {
            target.x -= bounds.x;
            target.y -= bounds.y;
        }

        container.name = containerName;
        parent.addChildAt(container, groupDepth);

        return container;
    } else {
        return targets as PIXIElement;
    }
}

export function Ungroup(container: PIXI.Container | PIXIGroup, containerName: string = "tempContainer", relayer: boolean = false) {
    if (container && container.name === containerName) {

        const containerParent = container.parent;

        const children = [...container.children];
        for (const child of children) {
            child.x += container.x - container.pivot.x;
            child.y += container.y - container.pivot.y;
            containerParent.addChild(child);
        }

        // relayer attempts to put grouped objects back in the layer order there were in before being grouped
        if (relayer) {
            if ((container as PIXIGroup).originalHierarchy) {
                for (const child of (container as PIXIGroup).originalHierarchy) {
                    if (child && child.parent === containerParent) {
                        containerParent.addChild(child);
                    }
                }
            }
        }

        containerParent.removeChild(container);
        container.destroy();
    }
}

export function CenterPivot(targets: PIXIElement | PIXIElement[], containerName?: string, pivotPoint?: Point): PIXIElement {
    if (!containerName) {
        containerName = "tempContainer";
    }

    const target = Group(targets, containerName);

    if (pivotPoint === undefined || pivotPoint === null) {
        pivotPoint = new Point(0.5, 0.5);
    }

    if ((target as any).anchor) {
        const anchorable = target as any;
        if (anchorable.anchor.x !== pivotPoint.x || anchorable.anchor.y !== pivotPoint.y) {
            anchorable.anchor.set(pivotPoint.x, pivotPoint.y);
            target.x += target.width * pivotPoint.x;
            target.y += target.height * pivotPoint.y;
        }
    } else {
        if (target.pivot.x === 0) {
            target.pivot.set(target.width * pivotPoint.x, target.height * pivotPoint.y);
            target.x += target.width * pivotPoint.x;
            target.y += target.height * pivotPoint.y;
        }
    }

    return target;
}

export function ResetPivot(target: PIXI.Container | PIXI.Sprite, containerName: string = "tempContainer") {
    if ((target as any).anchor) {
        const anchorable = target as any;
        target.x -= target.width * anchorable.anchor.x;
        target.y -= target.height * anchorable.anchor.y;
        anchorable.anchor.set(0);
    } else {
        target.x -= target.pivot.x;
        target.y -= target.pivot.y;
        target.pivot.set(0, 0);
    }
}

interface IDestroyOptions {
    children?: boolean;
    texture?: boolean;
    baseTexture?: boolean;
}

class PIXIGroup extends PIXI.Container {
    public originalHierarchy: PIXI.DisplayObject[];

    public destroy(options?: IDestroyOptions|boolean) {
        this.originalHierarchy = null;

        // super.destroy(options);
        super.destroy();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/pixi/group.ts